<template>
  <div class="icdDelivery" :class="{'custom-greed': customGreed}">
    <div class="wrapper">
      <p class="fs-36 bold color-black" v-if="!withoutTitle">
        {{ trans['included_in_delivery'] }}
      </p>

      <div class="grid-wrapper">
        <div
          v-for="item in includedInDeliveryList"
          :key="item.id"
          class="item"
        >
          <div v-if="item.type === 'image_and_text'" class="img-wrap">
            <img :alt="item.text" :src="item.file"/>
          </div>
          <p v-if="item.type === 'image_and_text'" class="text">{{ item.title }}</p>

          <div v-if="item.type === 'accessories_box'" class="img-wrap">
            <img alt="" src="/assets/images/builds/accessoriesID.png"/>
          </div>
          <p v-if="item.type === 'accessories_box'" class="text">
            {{ trans['accessories_box'] }}

            <button
              class="btn btn-link light"
              type="button"
              @click="showModal(item.text)"
            >
              {{ trans['learn_more'] }}
              <svg
                class="arr"
                fill="none"
                height="12"
                viewBox="0 0 14 9"
                width="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 0.999999L7 7L13 1"
                  stroke="black"
                  stroke-width="2"
                ></path>
              </svg>
            </button>
          </p>


          <div v-if="item.type === 'users_manual'" class="img-wrap">
            <a :class="manualLinkClass" :href="manualLink" target="_blank">
              <img v-if="item.type === 'users_manual'" src="/assets/images/builds/manualsID.png"/>
            </a>
          </div>
          <p v-if="item.type === 'users_manual'" class="text">
            {{ trans['user_manuals'] }}
          </p>

          <div v-if="item.type === 'securing_strap'" class="img-wrap">
            <a class="no-pointer" href="#" @click.prevent="noClick">
              <img alt="Securing strap" src="/assets/images/builds/strapID.png"/>
            </a>
          </div>
          <p v-if="item.type === 'securing_strap'" class="text">
            {{ trans['securing_strap'] }}
            <span class="sm">
              {{ trans['bike_transportation'] }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "IncludedInDelivery",
  props: ['trans', 'withoutTitle', "list", "customGreed"],
  computed: {
    ...mapGetters({
      preselected: "build/preselected",
      storage: 'storage'
    }),
    includedInDeliveryList() {
      if (this.list && Array.isArray(this.list) && this.list.length > 0) {
        return this.list
      }

      return this.preselected?.build?.included_in_delivery || []
    },
    build() {
      return this.preselected?.build || null
    },
    manualLink() {
      return this.build?.model_manual_link || null
    },
    manualLinkClass() {
      return {
        'no-pointer': !this.manualLink
      }
    },
  },
  methods: {
    noClick() {
    },
    showModal(text) {
      text = text.split("\n").map(item => {
        return this.trans[item]
      }).join('\n')
      this.$store.commit('changeModalTitle', 'The accessories box includes:')
      this.$store.commit('changeModalContent', text)
      this.$store.commit('changeModalOKBtnText', this.trans['Ok, I understand'])
      this.$store.commit('changeModalType', 'list')
      this.$store.commit('changeModalStatus', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.icdDelivery {
  margin-bottom: 98px;

  .fs-36 {
    //margin: 0 0 48px;
    margin: 0 0 32px;
    font-size: 24px;
  }

  .grid-wrapper {
    display: grid;
    grid-gap: 14px 12px;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    backdrop-filter: opacity(1);

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f9f9f9;
      border-radius: 16px;
      flex-wrap: wrap;
      padding: 30px 24px;

      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        .img-wrap {
          img {
            width: 70px;
          }
        }
      }

      .img-wrap {
        margin-bottom: 24px;

        img {
          mix-blend-mode: darken;
          height: 110px;
          max-width: 160px;
          object-fit: contain;
        }
      }

      .text {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #474747;
        line-height: 125%;
        margin: 0;

        .sm {
          color: #A3A3A3;
          font-size: 12px;
          line-height: 150%;
          display: block;
          margin: 4px 0 0;
        }
      }

      .btn.btn-link {
        display: flex;
        align-items: center;
        margin: 8px auto 0;
      }
    }
  }

  &.custom-greed {
    .wrapper{
      padding: 0;
    }
    .grid-wrapper {
      display: grid;
      grid-gap: 12px;
      width: 100%;
      grid-template-columns: repeat(6, 1fr);

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f9f9f9;
        border-radius: 8px;
        flex-wrap: wrap;
        padding: 12px 18px;

        &:nth-last-child(1),
        &:nth-last-child(2),
        &:nth-last-child(3) {
          .img-wrap img {
            width: 54px;
          }
        }

        .img-wrap {
          margin-bottom: 8px;

          img {
            height: 70px;
            max-width: 104px;
            object-fit: contain;
          }
        }

        .text {
          width: 100%;
          text-align: center;
          font-size: 14px;
          color: #474747;
          line-height: 125%;
          margin: 0;

          .sm {
            color: #a3a3a3;
            font-size: 12px;
            line-height: 150%;
            display: block;
            margin: 4px 0 0;
          }
        }

        .btn.btn-link {
          display: flex;
          align-items: center;
          margin: 8px auto 0;
        }
      }

      @media (max-width: 991px) {
        grid-gap: 20px 24px;
        grid-template-columns: repeat(3, 1fr);
      }
      @media (max-width: 575px) {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 24px 20px;

        .item {
          padding: 0;
          background-color: transparent;

          &:nth-last-child(1),
          &:nth-last-child(2),
          &:nth-last-child(3) {
            .img-wrap img {
              width: 40%;
              height: 40%;
            }
          }

          .img-wrap {
            background: #f8f8f8;
            border-radius: 7px;
            width: 100%;
            padding-top: 100%;
            margin-bottom: 14px;
            position: relative;

            img {
              width: 80%;
              height: 80%;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              margin: auto;
            }
          }

          .text {
            text-align: left;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }

  @media (max-width: 1300px) {
    .grid-wrapper {
      grid-gap: 10px;
    }
  }
  @media (max-width: 991px) {
    .grid-wrapper {
      grid-gap: 5px;

      .item {
        padding: 16px;
      }
    }
  }
  @media (max-width: 767px) {
    margin-bottom: 56px;
    .fs-36 {
      margin-bottom: 24px;
    }
    .grid-wrapper {
      grid-gap: 16px;

      .item {
        padding: 0;
        background-color: transparent;

        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8) {
          .img-wrap {
            img {
              width: 40%;
              height: 40%;
            }
          }
        }

        .img-wrap {
          background: #f8f8f8;
          border-radius: 7px;
          width: 100%;
          padding-top: 100%;
          margin-bottom: 14px;
          position: relative;

          img {
            width: 80%;
            height: 80%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
          }
        }

        .text {
          text-align: left;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
  @media (max-width: 575px) {
    .grid-wrapper {
      grid-gap: 24px 20px;
      grid-template-columns: repeat(2, 1fr);

      .item {
      }
    }
  }
}
</style>
